<template>
  <div>
    <h3>我是 C 网页</h3>
    <h4>{{ random }}</h4>
  </div>
</template>

<script>
  export default {
    name: 'page-c'
  };
</script>

<style lang="scss" scoped>

</style>